export default __webpack_public_path__ + "static/media/microneedling.db65d856.pdf";